import type { AcceptedDetails } from "../_model";
import { t } from "../i18n";
import { locale } from "../../SHARED/i18n";
import Wallet from "../assets/wallet.svg";
import { createMemo } from "solid-js";

function downloadURI(uri: string, fileName: string) {
  // const fileName = uri.substring(uri.lastIndexOf("/") + 1);
  const fileUrl = uri;
  // https://thingproxy.freeboard.io/ | https://corsproxy.io/ | https://cors-anywhere.herokuapp.com/
  const proxyUrl = "https://corsproxy.io/?url=" + encodeURIComponent(fileUrl);
  // const proxyUrl = fileUrl;

  fetch(proxyUrl)
    .then((response) => response.blob())
    .then((blob) => {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.target = "_blank";
      link.rel = "noreferrer noopener";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    .catch((error) => {
      console.error("Error downloading the file:", error);
    });
}

export default function (props: { details: AcceptedDetails }) {
  const $guide_link = createMemo(() => {
    if (locale() === "en") {
      return props.details.guide_en;
    }
    return props.details.guide_ar;
  });
  const $guide_name = createMemo(() => {
    if (locale() === "en") {
      return "Designathon-2025-Guideline-EN.pdf";
    }
    return "Designathon-2025-Guideline-AR.pdf";
  });
  const badge_link = props.details.badge;
  const badge_name = "Designathon-2025-Badge.png";
  const wallet_link = props.details.apple_walled;
  const wallet_name = "Designathon-2025-Badge.pkpass";
  return (
    <section class="flex flex-col w-full h-full pt-10 pb-2 gap-4 overflow-y-auto">
      <p class="flex flex-col gap-0.5 font-600 text-35px">
        <span>{t().welcome.start}</span>
        <span class="capitalize">{locale() === "en" ? props?.details.name_en : props?.details.name_ar}</span>
        <span>{t().welcome.end}</span>
      </p>
      {/* guide */}
      <div class="flex flex-col gap-2">
        <p class="flex flex-row gap-2 text-20px items-center justify-start font-600 gap-2 capitalize">
          <span class="i-icon-park-solid:pin w-24px h-24px text-error -rotate-90 rtl:rotate-0"></span>
          <span>{t().guide.label}:</span>
        </p>
        <p class="text-16px">{t().guide.instructions}</p>
        <div class="flex flex-col gap-2">
          <DownloadButton
            label={t().guide.button}
            icon="i-basil:document-solid"
            link={$guide_link()}
            name={$guide_name()}
          />
          <span class="text-text-alt text-14px">{t().caution}</span>
        </div>
      </div>
      {/* badge */}
      <div class="flex flex-col gap-2">
        <p class="flex flex-row gap-2 items-center justify-start text-20px font-600 gap-2 capitalize">
          <span class="i-zondicons:badge w-24px h-24px text-error"></span>
          <span>{t().badge.label}:</span>
        </p>
        <p class="text-16px <sm:(text-justify)">{t().guide.instructions}</p>
        {/* buttons */}
        <div class="flex flex-row w-full gap-2 items-center justify-start <sm:(!flex-col)">
          {/* badge */}
          <div class="flex flex-col <sm:(w-full)">
            <DownloadButton
              label={t().badge.buttons.badge}
              icon="i-flowbite:ticket-solid"
              link={badge_link}
              name={badge_name}
            />
          </div>
          {/* wallet */}
          <div class="flex flex-col <sm:(w-full)">
            <DownloadButton
              label={
                <p class="flex flex-row w-90% items-start justify-start gap-1 <sm:(!justify-center text-center)">
                  <span>{t().badge.buttons.addTo.title}</span>
                  <span class="capitalize">{t().badge.buttons.addTo.wallet}</span>
                </p>
              }
              icon={<Wallet />}
              link={wallet_link}
              name={wallet_name}
              class="bg-text text-bg !border-0"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function DownloadButton(props: {
  label: string | JSX.Element;
  icon: string | JSX.Element;
  link: string;
  name: string;
  class?: string;
}) {
  return (
    <p
      class={
        (props.class ?? "") +
        " " +
        "flex flex-row w-fit h-fit gap-2 items-center justify-between capitalize text-16px py-2 px-2 border-text-alt border-solid border-2 rounded-md cursor-pointer <sm:(!w-full)"
      }
      onclick={() => downloadURI(props.link, props.name)}
    >
      {typeof props.icon === "string" ? (
        <span class={(props.icon ?? "") + " w-24px h-24px text-text-alt"}></span>
      ) : (
        props.icon
      )}
      {typeof props.label === "string" ? <span>{props.label}</span> : props.label}
      <span class="i-line-md:download-loop w-24px h-24px text-text-alt"></span>
    </p>
  );
}
